export default "https://cdn-static.gokick.com/assets/e732fce3df71ad981aa0ee65436659b369042414/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";